import React from "react";
import LinkWrapper from "../../linkWrapper/LinkWrapper";
import { getLink, getNodesCount } from "../utils";

const MobileNavMenu = ({ content }) => {
    return (
        <nav className="offcanvas-navigation" id="offcanvas-navigation">
            {content["@nodes"] && (
                <ul>
                    {content["@nodes"].map((nodeName) => {
                        const hasNodes = getNodesCount(content[nodeName]) > 0;

                        return (
                            <li key={nodeName} className={hasNodes ? "menu-item-has-children" : null}>
                                <LinkWrapper
                                    linkNode={content[nodeName].link}
                                    linkClass="menu-link"
                                    renderChildren={true}
                                    fallbackWrapperEl="span"
                                >
                                    {content[nodeName].link.label}
                                </LinkWrapper>

                                {hasNodes && (
                                    <ul className="sub-menu">
                                        {content[nodeName]["@nodes"].map((childNodeName) => {
                                            if (childNodeName === "link") return null;

                                            const link = getLink(content[nodeName], childNodeName);
                                            const hasChildNodes = getNodesCount(content[nodeName][childNodeName]) > 0;

                                            return (
                                                <li key={childNodeName} className={hasChildNodes ? "menu-item-has-children" : null}>
                                                    {link.linkNode && link.label && (
                                                        <LinkWrapper
                                                            linkNode={link.linkNode}
                                                            renderChildren={true}
                                                            fallbackWrapperEl="span"
                                                        >
                                                            {link.label}
                                                        </LinkWrapper>
                                                    )}

                                                    {hasChildNodes && (
                                                        <ul className="sub-menu">
                                                            {content[nodeName][childNodeName]["@nodes"].map((subchildNodeName) => {
                                                                if (subchildNodeName === "link") return null;

                                                                const link = getLink(content[nodeName][childNodeName], subchildNodeName);

                                                                if (!link.linkNode || !link.label) return null;

                                                                return (
                                                                    <li key={subchildNodeName}>
                                                                        <LinkWrapper
                                                                            key={subchildNodeName}
                                                                            linkNode={link.linkNode}
                                                                            renderChildren={true}
                                                                            fallbackWrapperEl="span"
                                                                        >
                                                                            {link.label}
                                                                        </LinkWrapper>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    )}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </nav>
    );
};

export default MobileNavMenu;
